/* globals lp,  editor */
var InvariantsHelper = require('./invariants-helper');
var jQuery = require('jquery');
var _ = require('lodash');

;(function() {
  var assert   = lp.invariants.assert
    , register = lp.invariants.register
    , helper   = InvariantsHelper;

  // ************************ Helpers functions **************************

  //////////////////////////////////////////////////////////////////////
  // core set of example invariants:
  register(
    'editor.page is defined',
    function(editor) {
      return !!editor.page;
    }
  );

  register(
    'editor.mainPage is defined',
    function(editor) {
      return !!editor.mainPage;
    }
  );

  register(
    'editor.activeElement.page === editor.page',
    function(editor) {
      return (editor.activeElement === null) || (
        editor.activeElement.page === editor.page);
    }
  );

  register(
    'editor.activeElement null or valid element',
    function(editor) {
      var activeEl = editor.activeElement;
      if (activeEl === null) {
        return true;
      } else {
        return editor.page.getElementById(activeEl.id) === activeEl;
      }
    }
  );

  register(
    'editor.activeElement.id is the active element in DOM',
    function(editor, assert) {
      var activeEl = editor.activeElement;
      if (activeEl === null || jQuery('.lp-active-element').length === 0 ) {
        return true;
      } else if(activeEl.id.indexOf('lp-multi-select') > -1) {
        //If the active element make sure that at least one of the elements in the group
        //are active.
        // Even though the selected elements are not the
        // editor.activeElement, the first one selected will be marked
        // in the dom with class lp-activeElement.
        var hasActiveElm = _.some(activeEl.selection, function(el) {
          return jQuery('#' + el.id).hasClass('lp-active-element');
        });
        return assert(hasActiveElm, 'None of the elements in the multi select are marked active');
      } else {
        return assert(jQuery('.lp-active-element').attr('id') === activeEl.id);
      }
    }
  );

  register(
    'editor.activeElement properties panel default tab looks correct',
    function(editor, assert) {
      var activeEl = editor.activeElement;
      if (activeEl === null) {
        return true;
      } else if (activeEl.id === 'lp-pom-root') {
        // on form confirmation or lightbox page both the conversion goals and the element props are disabled
        var expectedDisabled = editor.page.isFormConfirmation() ? 2 : 1;
        return assert(jQuery('#editor-info-panel').find('.tab-bar > .tab.dsbl').length === expectedDisabled);
      } else {
        var panel = activeEl.getModule().getElementPropertiesPanel();
        return panel.element === activeEl;
      }
    }
  );

  register(
    'editor.activeElement is in sync with editor.flashBox',
    function(editor, assert) {
      var activeEl = editor.activeElement;
      if (activeEl === null) {
        return true;
      } else if (activeEl.id === 'lp-pom-root') {
        return assert(
          editor.flashBox.elm === null || _.isUndefined(editor.flashBox.elm));
      } else {
        return assert(editor.flashBox.elm === activeEl);
      }
    }
  );

  register(
    'BreakpointButtonsPresent',
    function(editor) {
      if (editor.mainPage.getConfigValue('allowResponsive') && editor.mainPage.getConfigValue('showResponsiveControls')) {
        return !_.isEmpty(jQuery("[data-role='desktop-breakpoint-button']")) &&
          !_.isEmpty(jQuery("[data-role='mobile-breakpoint-button']"));
      } else {
        return true;
      }
    }
  );

  register('CheckCorrectPropertiesPanelForSelectedElement', function() {
    if (helper.isNonRootElementSelectedAndPropertiesPanelVisible()) {
      var activeEl = editor.activeElement;

      // Lightbox buttons use a different title than their actual type
      // (lp-pom-lightbox-button). For now we'll just disable this invariant for them.
      if (activeEl.type === 'lp-pom-button' && _.contains(['externalLightbox', 'internalLightbox'], activeEl.model.safeGet('action.type'))) {
        return true;
      }

      return assert(
        helper.hasElementInPanel(activeEl.type, "properties"),
        "Incorrect properties panel showing up for the selected element"
      );
    } else {
      return true;
    }
  });

  register('CheckVisibilityOnCanvasAndPanel', function() {
    var $propertiesPanel = jQuery(helper.panelSelectorMapping.properties);
    if(helper.isNonRootElementSelectedAndPropertiesPanelVisible()) {
      return assert(
        editor.activeElement.isVisibleOnPage() !== $propertiesPanel.find(".visibility-state").hasClass("lp-hidden"),
        "Visibility of element on canvas and properties panel do not match"
      );
    } else {
      return true;
    }
  });

  register('CheckSchemaValidity', function(editor, assert) {
    // PB-2236: Why does it use this method? It should just get as close to the
    //          original data as possible. The `toJSO()` method called by
    //          `elementsAsJSO` contains a side effect that updates the model
    //          data directly. Invariants should not be modifying the data they
    //          are checking ever.
    var elementsJSO = _(editor.pages)
      .map(function(page) {return page.elementsAsJSO();})
      .flatten()
      .value();

    var validation = window.pomValidator.validate_elements(JSON.parse(JSON.stringify(elementsJSO)));
    if ( ! validation.valid) { console.log(validation); }
    return assert(validation.valid, validation.errors);
  });

  // example of nested invariant groups

  // register('foo',
  //          {"bar": function() {return false;},
  //           "baz": function() {return true;},
  //           "sub": {"bar": function() {return true;},
  //                   "baz": function() {return true;}
  //          }
  //          });

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/invariants/core-invariants.js
// module id = 1071
// module chunks = 0